export const SUMMARY_COLUMNS = [
  { id: "Source", label: "Dataset", align: "left", sortable: true },
  { id: "TotalCount", label: "Total Records", align: "center", sortable: true },
  { id: "Clean", label: "Clean Records", align: "center", sortable: true },
  { id: "Acceptable", label: "Warning Records", align: "center", sortable: true },
  { id: "Critical", label: "Critical Records", align: "center", sortable: true },
  { id: "RecDate", label: "Last DQM Run", align: "center", sortable: true },
  { id: "Health", label: "Data Health", align: "center", sortable: true },
];

export const DASHBOARD_COLUMNS = [
  { id: "RuleName", label: "Rule", align: "left", sortable: true },
  { id: "CategoryName", label: "Category", align: "left", sortable: true },
  { id: "Attribute", label: "Attribute", align: "left", sortable: true },
  { id: "Health", label: "Data Health", align: "center", sortable: true },
  { id: "Findings", label: "Findings", align: "right", sortable: true },
  { id: "Alert_When", label: "Alert When", align: "right" },
];

export const CATEGORIES = [
  { label: "Validity", value: "Validity", color: "#6A5ACD" },
  { label: "Uniqueness", value: "Uniqueness", color: "#FF6F61" },
  { label: "Consistency", value: "Consistency", color: "#E1AD01" },
  { label: "Integrity", value: "Integrity", color: "#D81B60" },
  { label: "Completeness", value: "Completeness", color: "#7ED321" },
  { label: "Accuracy", value: "Accuracy", color: "#4A90E2" },
  { label: "Timeliness", value: "Timeliness", color: "#9B59B6" },
];

export const CRITICALITY = [
  { label: "Critical", value: "Critical" },
  { label: "Warning", value: "Acceptable" },
];
